---
nb:
  work_items:
    add_attachment: Legg til vedlegg
    attachments: Vedlegg
    average_cost_per_closed_work_item: Gjennomsnittlig kostnad per lukket oppgave
    average_days_to_close_work_item: Gjennomsnittlig antall dager det tar å lukke en oppgave
    budget_cost: Budsjettpris
    closed_tasks: Lukkede oppgaver
    closed_work_items: Lukkede oppgaver
    due_date: Forfallsdato
    error_deleting: Det oppstod et problem med sletting av oppgaven
    filter_responsibles: Filtrer ansvarlige
    forecast_cost: Prognosekostnad
    history: Historie
    label_in_use: Brukes av {count} oppgave. Kontakt support for å endre den. | Brukes av {count} oppgaver. Kontakt support for å endre den.
    label_in_use_error:
      one: Denne merkelappen brukes av én oppgave, så bare support kan endre den.
      other: Denne merkelappen brukes av %{count} oppgaver, så bare support kan endre den.
    model_name: oppgave
    move: Flytt
    moved_work_item_from: flyttet aktivitet fra
    new_label: Ny etikett
    no_attachments: Ingen vedlegg
    not_allowed_to_delete: Du kan kun slette oppgaver du har laget
    number_of_projects: Antall prosjekter
    number_of_work_items: Antall oppgaver
    open_work_items: Åpne oppgaver
    opened_work_item: Åpnet oppgave
    project_status: Prosjektstatus
    reassigned_work_item_from: overførte oppgave fra
    show_closed_tasks: Vis lukkede oppgaver
    show_on_hold_tasks: Vis oppgaver som er satt på vent
    show_only_closed_tasks: Vis kun lukkede oppgaver
    show_only_on_hold_tasks: Vis kun oppgaver som er satt på vent
    started_on: Startet
    status:
      closed: Lukket
      in_progress: Pågår
      on_hold: Satt på vent
      open: Åpen
    sum_total_cost: Total kostnadssum
    today: I dag
    total_budget_cost: Total budsjettpris
    total_closed_cost: Total kostnad for lukkede oppgaver
    total_closed_cost_by_month: Total kostnad for lukkede oppgaver per måned
    total_cost_by_month: Estimert oppgavekostnad
    total_in_progress_cost: Total kostnad for pågående oppgaver
    total_open_cost: Total kostnad for åpne oppgaver
    total_open_cost_by_month: Total kostnad for åpne oppgaver per måned
    validations:
      select_power_plant_first: Velg kraftverk først
    work_item_labels: Oppgaveetiketter
    work_item_total_cost_by_month: Estimert oppgavekostnad per måned
    work_items_by_component: Oppgavefordeling basert på komponent
    work_items_by_status_by_month: Åpne og lukkede oppgaver per måned
